import React from "react";
import { m } from "kremling";

type EmptyCellProps = {
  isDisabled?: boolean;
};

export function EmptyCell({ isDisabled }: EmptyCellProps) {
  return <span className={m("cp-table-cell-disabled", isDisabled)}>—</span>;
}
